export default "__VITE_ASSET__55ca62e0__"